// Suggest quantities only. The existing server quote and invitation/employee
// capacity checks remain authoritative; this does not reserve a place.
export function employeeWithLoginSelection({ limits, usage, items, offers, quantities, cycle }) {
    const selection = { ...quantities };
    const keys = ['maxEmployees', 'maxUsers'];
    const capacity = {};
    for (const key of keys) {
        if (!Number.isSafeInteger(usage[key]) || usage[key] < 0 || (limits[key] !== null && (!Number.isSafeInteger(limits[key]) || limits[key] < 0))) throw new Error('Kapaciteten kunde inte verifieras. Hämta sidan igen.');
        capacity[key] = limits[key] === null ? Infinity : limits[key];
        for (const offer of offers) {
            const current = items.find(item => item.code === offer.code)?.quantity || 0;
            const target = selection[offer.code] || 0;
            if (!Number.isSafeInteger(target) || target < 0) throw new Error('Ange ett giltigt antal extra platser.');
            capacity[key] += (target - current) * (offer.payload.limits[key] || 0);
        }
    }
    for (const [key, code] of [['maxEmployees', 'extra_employee'], ['maxUsers', 'extra_user']]) {
        const missing = Math.max(0, usage[key] + 1 - capacity[key]);
        if (!missing) continue;
        const offer = offers.find(item => item.code === code && item.prices.some(price => price.billingCycle === cycle));
        const unit = offer?.payload.limits[key];
        if (!Number.isSafeInteger(unit) || unit <= 0) throw new Error('En extra plats saknar ett tillgängligt pris för din betalningsperiod.');
        const quantity = Math.ceil(missing / unit);
        selection[code] = (selection[code] || 0) + quantity;
        for (const affected of keys) capacity[affected] += quantity * (offer.payload.limits[affected] || 0);
    }
    return selection;
}
